import React, { useEffect } from 'react';
import { Popover, Steps } from 'antd';
const customDot = (dot, { status, index }) => {
  return dot;
};      


const description = 'United States of america';
const description1 = 'Applcation Id 112213';
const description2 = 'You can hover on the dot.';

export default function Stepbarstep(data) {
  useEffect(() => {
  });
  return (
    <div>
         <Steps
    current={2}
    progressDot={customDot}
    items={[
      {
        title: data.data.university,
        description:data.data.country,
      },
      {
        title:data.data.name,
        description:'ApplicationId:'+' '+ data.data.applicationId,
      },
      {
        title: 'Intake:'+' '+data.data.intake,
        description:'Year: '+' '+data.data.year,
      },

    ]}
  />
    </div>
  )
}
